import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchTabledata, fetchTabledataColum } from "../common/common";

const DropdownContext = createContext({});

export const DropdownProvider = ({ children }) => {
  const [dropdowns, setDropdowns] = useState({});

  const workflowStatusOptions = [
    { value: "Received", label: "Received" },
    { value: "Quality Assessment – Pass", label: "Quality Assessment – Pass" },
    { value: "Quality Assessment – Pass with issues", label: "Quality Assessment – Pass with issues" },
    { value: "Quality Assessment – Fail", label: "Quality Assessment – Fail" },
  ];

  const sortByDisplayedName = (data) => {
    return [...data].sort((a, b) => {
      const nameA = (a.label || a.name || "").toLowerCase();
      const nameB = (b.label || b.name || "").toLowerCase();
      return nameA.localeCompare(nameB);
    });
  };

  // ✅ REFRESH FUNCTION
  const refreshDropdowns = async () => {
    const [
      workType,
      dno,
      region,
      priority,
      idno,
      npgUser,
      contractor,
      reqtype,
      reqstatus,
      level,
      documenttype,
      querystatus1,
      qtypes,
      npgContact,icp
    ] = await Promise.all([
      new Promise((resolve) =>
        fetchTabledataColum("tblworktypelkp", "flowline", "bau", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tbldnoarea_lkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tblregion_lkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tblprioritylkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tbl_idno_lkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("vw_im_job_owners", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tblcontractorlkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tbl_requesttype_lkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tbl_rfc_status_lkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tbl_level_lkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("document_types", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tbl_query_statuslist", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tbl_query_types", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("npgcontact_lkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
      new Promise((resolve) =>
        fetchTabledata("tbl_icp_lkp", (data) =>
          resolve(sortByDisplayedName(data))
        )
      ),
    ]);

    setDropdowns({
      workType,
      dno,
      region,
      priority,
      idno,
      npgUser,
      contractor,
      reqtype,
      reqstatus,
      level,
      documenttype,
      workflowStatusOptions,
      querystatus1,
      qtypes,
      npgContact,
      icp
    });
  };

  // initial load
  useEffect(() => {
    refreshDropdowns();
  }, []);

  return (
    <DropdownContext.Provider value={{ ...dropdowns, refreshDropdowns }}>
      {children}
    </DropdownContext.Provider>
  );
};

export const useDropdowns = () => useContext(DropdownContext);